import { getCVTypeFile, getCVTypeUrl } from "../lists/other";

export const formatQualificationCvDataFormValues = (associate, language = 'pt') => { 

    if(associate.qualificationData.cvUrl === "") {
        associate.qualificationData.cvType = getCVTypeFile(language);
    }
    else {
        associate.qualificationData.cvType = getCVTypeUrl(language);
    }

    return associate;
}

export const formatCvDataToService = (associate) => { 
    return associate;
}